"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPopover = require("@tencent/spaui-popover");

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

var _info = _interopRequireDefault(require("./info"));

var _button_compact_props = _interopRequireDefault(require("./button_compact_props"));

var _button_props = require("./button_props");

var _spauiLoading = _interopRequireDefault(require("@tencent/spaui-loading"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Button =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Button, _PureComponent);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this, props));
    _this.state = {
      popoverShow: false
    };
    return _this;
  }

  _createClass(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
    /**
     * 获取尺寸对应的className
     * @private
     * @return {string} 尺寸对应的classname
     */

  }, {
    key: "getSizeClassName",
    value: function getSizeClassName() {
      var _compactProps = (0, _button_compact_props["default"])(this.props),
          size = _compactProps.size,
          baseClass = _compactProps.baseClass;

      var result = '';

      switch (size) {
        case 'xsmall':
        case 'xs':
          result = "".concat(baseClass, "-xs");
          break;

        case 'small':
        case 'sm':
          result = "".concat(baseClass, "-sm");
          break;

        case 'large':
        case 'lg':
          result = "".concat(baseClass, "-lg");
          break;

        case 'extralarge':
        case 'xlg':
          result = "".concat(baseClass, "-xlg");
          break;
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _compactProps2 = (0, _button_compact_props["default"])(this.props),
          supportEvents = _compactProps2.supportEvents,
          target = _compactProps2.target,
          type = _compactProps2.type,
          children = _compactProps2.children,
          loading = _compactProps2.loading,
          LoadingComponent = _compactProps2.LoadingComponent,
          dropdown = _compactProps2.dropdown,
          active = _compactProps2.active,
          block = _compactProps2.block,
          tagType = _compactProps2.tagType,
          href = _compactProps2.href,
          disabled = _compactProps2.disabled,
          tip = _compactProps2.tip,
          tipSequence = _compactProps2.tipSequence,
          baseClass = _compactProps2.baseClass,
          displayType = _compactProps2.displayType,
          _compactProps2$useBas = _compactProps2.useBaseClass,
          useBaseClass = _compactProps2$useBas === void 0 ? true : _compactProps2$useBas,
          _compactProps2$Overla = _compactProps2.OverlayTriggerProps,
          OverlayTriggerProps = _compactProps2$Overla === void 0 ? {} : _compactProps2$Overla,
          _compactProps2$title = _compactProps2.title,
          title = _compactProps2$title === void 0 ? '' : _compactProps2$title,
          isAlone = _compactProps2.isAlone,
          _compactProps2$withTi = _compactProps2.withTipClassName,
          withTipClassName = _compactProps2$withTi === void 0 ? '' : _compactProps2$withTi,
          _compactProps2$popove = _compactProps2.popoverProps,
          popoverProps = _compactProps2$popove === void 0 ? {} : _compactProps2$popove,
          _compactProps2$show = _compactProps2.show,
          show = _compactProps2$show === void 0 ? true : _compactProps2$show,
          icon = _compactProps2.icon,
          endIcon = _compactProps2.endIcon,
          isCompound = _compactProps2.isCompound,
          width = _compactProps2.width,
          height = _compactProps2.height,
          radius = _compactProps2.radius,
          padding = _compactProps2.padding,
          style = _compactProps2.style,
          hasSpan = _compactProps2.hasSpan;

      var defaultEvents = ['onClick', 'onMouseOver', 'onMouseOut', 'onMouseEnter', 'onMouseLeave', 'onMouseUp'];
      var defaultSupportEvents = disabled ? [] : defaultEvents;
      var useEvents = typeof supportEvents === 'undefined' ? defaultSupportEvents : supportEvents;
      var tagEvents = {};
      var tagProps = {};
      var Tag = '';
      var tagDom = null;
      var result = null;
      var childrenDom = null;
      var dropdownButtonClassName = '';
      var tipTarget = this.props.tipTarget || null;

      if (!show) {
        return null;
      } // tag标签的相关属性


      if (href) {
        tagProps.href = href;
        tagProps.target = target;
      } else {
        tagProps.type = type;
      }

      tagProps.disabled = disabled;

      if (typeof title === 'string' && title || typeof title === 'number') {
        tagProps.title = title;
      }

      var cssText = (0, _spauiUtils.removeUndefined)(_objectSpread({
        width: (0, _spauiUtils.pxVal)(width),
        height: (0, _spauiUtils.pxVal)(height),
        borderRadius: (0, _spauiUtils.pxVal)(radius),
        padding: (0, _spauiUtils.pxVal)(padding)
      }, style)); // 支持的操作事件

      useEvents.map(function (item) {
        tagEvents[item] = _this2.props[item];
        return item;
      }); // 有链接的时候应该用a标签 外部按钮禁用但是需要展示tip的时候

      if (href && tagType === 'button' || tagType === 'button' && disabled && tip) {
        Tag = 'a';
      } else {
        Tag = tagType;
      } // 需要回传props，这样才能够自己判断说当前对应的按钮是哪个


      var onShowChange = function onShowChange(event, showResult) {
        _this2.setState({
          popoverShow: showResult
        });
      };

      if ((0, _spauiUtils.isFunction)(OverlayTriggerProps.onShowChange) || (0, _spauiUtils.isFunction)(OverlayTriggerProps.onShow)) {
        onShowChange = function onShowChange(event, showResult) {
          if ((0, _spauiUtils.isFunction)(OverlayTriggerProps.onShowChange)) {
            OverlayTriggerProps.onShowChange(event, showResult, _this2.props);
          } else if ((0, _spauiUtils.isFunction)(OverlayTriggerProps.onShow)) {
            OverlayTriggerProps.onShow(event, showResult, _this2.props);
          }

          _this2.setState({
            popoverShow: showResult
          });
        };
      }

      if (loading) {
        if (typeof LoadingComponent !== 'undefined' && LoadingComponent) {
          if ((0, _spauiUtils.isReactNode)(LoadingComponent)) {
            childrenDom = LoadingComponent;
          } else {
            childrenDom = _react["default"].createElement(LoadingComponent, null);
          }
        } else if (displayType === 'default' || !displayType) {
          childrenDom = _react["default"].createElement(_spauiLoading["default"], {
            display: "center"
          });
        } else {
          childrenDom = _react["default"].createElement(_spauiLoading["default"], {
            display: "center",
            className: "spaui-loading-light"
          });
        }
      } else if (dropdown) {
        childrenDom = _react["default"].createElement(_spauiIcon["default"], {
          name: "dropdown-arrow-outlined",
          className: "spaui-button-darr"
        });
        dropdownButtonClassName = "spaui-button-".concat(displayType, "-dropdown");
      } else if (hasSpan) {
        childrenDom = _react["default"].createElement("span", {
          className: "spaui-button-label"
        }, children);
      } else {
        childrenDom = children;
      }

      var theOverlayTriggerProps = _objectSpread({}, _button_props.buttonPropsDefaultData.OverlayTriggerProps, {}, OverlayTriggerProps);

      var triggerPropsShow = theOverlayTriggerProps.show;
      var popoverShow = typeof triggerPropsShow !== 'undefined' ? triggerPropsShow : this.state.popoverShow;

      if (tip && tipTarget) {
        tipTarget = _react["default"].createElement(_spauiPopover.OverlayTrigger, _extends({
          overlay: _react["default"].createElement(_spauiPopover.PopOver, popoverProps, tip)
        }, theOverlayTriggerProps, {
          show: popoverShow,
          onShowChange: onShowChange
        }), tipTarget);
      } // tag实例化


      tagDom = _react["default"].createElement(Tag, _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(useBaseClass ? baseClass : '', "".concat(baseClass, "-").concat(displayType), block ? "".concat(baseClass, "-block") : '', this.getSizeClassName(), dropdownButtonClassName, _defineProperty({
          active: active,
          'btn-loading': loading,
          'is-alone': isAlone,
          'is-compound': isCompound,
          'with-icon': icon || endIcon
        }, withTipClassName, popoverShow && tip && tipTarget))
      }, Button), {
        style: cssText
      }, tagProps, tagEvents), tip && tipSequence === 'first' ? tipTarget : null, icon, childrenDom, endIcon, tip && tipSequence === 'last' ? tipTarget : null); // 浮层

      if (tip && !tipTarget) {
        result = _react["default"].createElement(_spauiPopover.OverlayTrigger, _extends({
          overlay: _react["default"].createElement(_spauiPopover.PopOver, popoverProps, tip)
        }, _button_props.buttonPropsDefaultData.OverlayTriggerProps, OverlayTriggerProps, {
          onShowChange: onShowChange
        }), tagDom);
      } else {
        result = tagDom;
      }

      return result;
    }
  }]);

  return Button;
}(_react.PureComponent); // 组件标记


_defineProperty(Button, "propTypes", _button_props.propTypes);

_defineProperty(Button, "defaultProps", _button_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Button, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Button;
exports["default"] = _default;